import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { getIndex } from "../plugins/util";
import { getHeaderTitle } from "@/plugins/data";
const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior: () => ({ left: 0 /* top: 0*/ }),
});

/**
 * @description 路由拦截 beforeEach
 * */
router.beforeEach((to, from, next) => {
	const { path } = to;
	if (path.includes("/home")) {

		document.title = getHeaderTitle(getIndex());
	} else if (path.includes("/enterpriseList")) {
		document.title = "企业列表";
	}
	// console.log(to, from, next, "????");
	next();
});

router.afterEach(() => {
	// console.log("afterEach????");
});

/**
 * @description 路由跳转错误
 * */

router.onError((error) => {
	console.warn("路由错误", error.message);
});

export default router;
